import React, { useEffect } from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import VerticalLayout from "components/VerticalLayout"
import HorizontalLayout from "components/HorizontalLayout"

//constants
import { layoutTypes } from "../../constants/layout"

const Usermiddleware = props => {
  const location = useLocation()

  useEffect(() => {
    console.log("location", location)
  }, [location])

  const layoutType = useSelector(state => state.Layout.layoutType)
  const token = useSelector(state => state.auth.token)
  const user = useSelector(state => state.auth.user)

  const getLayout = layoutType => {
    let Layout = VerticalLayout
    switch (layoutType) {
      case layoutTypes.VERTICAL:
        Layout = VerticalLayout
        break
      case layoutTypes.HORIZONTAL:
        Layout = HorizontalLayout
        break
      default:
        break
    }
    return Layout
  }

  // Redirect if not authenticated - return Navigate to prevent rendering below
  if (token === null) {
    console.log("in user middleware if")
    return (
      <Navigate to="/login" state={{ from: location.pathname }} replace />
    )
  }

  // Redirect if admin user tries to access user routes
  if (user && user.user_type === "admin") {
    console.log("invalid user")
    return <Navigate to="/unauthorized" replace />
  }

  const Layout = getLayout(layoutType)

  return (
    <React.Fragment>
      <Layout>{props.children}</Layout>
    </React.Fragment>
  )
}

export default Usermiddleware
